import { styled } from "../../../../styles";

// EN-5067: full-width header + info note that sit above the wrapping FormField grid inside the
// shared SectionContainer.
export const SectionHeader = styled("div", {
  flexBasis: "100%",
  minWidth: "100%",
  marginBottom: "20px",
  padding: "0 30px",
});

export const SectionTitle = styled("h3", {
  margin: 0,
  color: "$charcoal",
  fontSize: "16px",
  fontWeight: 600,
  fontFamily: "$openSans",
});

export const RequiredHint = styled("span", {
  marginLeft: "6px",
  color: "$secondary",
  fontSize: "12px",
  fontWeight: 600,
});

// Aligns the YesNo toggle to the left of the field row (matching the inputs' left edge).
export const ToggleContainer = styled("div", {
  width: "410px",
  display: "flex",
  alignItems: "center",
});
